<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="700px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span>Nội dung</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="item.title"
                label="Tiêu đề"
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <label>Nội dung câu hỏi</label>
              <quill-editor
                v-model="item.message"
                :options="editorOption"
                style="min-height:150px;"
              >
              </quill-editor>
            </v-col>
            <template 
              v-if="item.contact_images && item.contact_images.length > 0"
            >
              <v-col
                cols="12"
                class="py-0"
              >
                <div>Hình ảnh kèm theo</div>
              </v-col>
              <v-col
                cols="12"
                style="padding: 24px;"
              >
                <v-row 
                  justify="center" 
                  style="border: 2px dashed;border-radius: 4px;"
                >
                  <v-col 
                    cols="auto"
                    class="mx-auto " 
                    v-for="(contact_img, index) in item.contact_images"
                    :key="`contact_img${index}`"
                  >
                    <a :href="`${apiBaseUrl}/uploads/${contact_img.path}`" target="_blank">
                      <v-img
                        :src="`${apiBaseUrl}/uploads/${contact_img.path}`"
                        lazy-src="@/assets/NoImage.jpg"
                        width="100"
                        aspect-ratio="1"
                        class="grey lighten-2"
                      />
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </template>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Đóng lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapState, mapActions  } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        editorOption: {}
      }
    },
    computed: {
      ...mapState([ 
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        const app = this;
        app.dialog = false;
        if (app.showDialog) {
          app.dialog = true;
          if(!app.item.trang_thai) {
            app.item.trang_thai=1;
            axios.patch(`api/v1/contacts/${app.item.id}`, app.item)
              .then(response => {
                app.countContact();
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'countContact'
      ]),
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      }
    }
  }
</script>